import React, { useState } from 'react';
import '../../styles/quiz-base.css';
import './genero.css'; // Pode continuar usando para estilos extras se quiser
import Footer from '../../components/footer/Footer';

const API_BASE = process.env.REACT_APP_API_BASE;

const Genero = ({ onSucesso }) => {
  const [selecionado, setSelecionado] = useState('');
  const [enviando, setEnviando] = useState(false);
  const [erro, setErro] = useState('');

  const opcoes = [
    { label: 'Masculino', valor: 'masculino', emoji: '👨' },
    { label: 'Feminino', valor: 'feminino', emoji: '👩' },
    { label: 'Outro', valor: 'outro', emoji: '🏳️‍🌈' }
  ];

  const handleEnviar = async () => {
    if (!selecionado) return;

    setEnviando(true);
    setErro('');

    try {
      const resposta = await fetch(`${API_BASE}/salvar-etapa.php`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({
          campo: 'genero',
          valor: selecionado
        })
      });

      const dados = await resposta.json();

      if (dados.status === 'sucesso') {
        onSucesso(); // próxima etapa
      } else {
        setErro(dados.mensagem || 'Erro ao salvar. Tente novamente.');
      }
    } catch (error) {
      setErro('Erro de conexão com o servidor.');
    }

    setEnviando(false);
  };

  return (
    <div className="quiz-etapa">
      {/* ✅ Logo no topo */}
      <img src="/assets/logo1.png" alt="Logo NutriFitMe" className="quiz-logo" />

      {/* ✅ Barra de progresso */}
      <div className="quiz-progresso">
        <div className="quiz-progresso-barra">
          <div className="quiz-progresso-preenchido" style={{ width: '14.2%' }}></div>
        </div>
        <div className="quiz-progresso-texto">1 de 7</div>
      </div>

      {/* ✅ Pergunta */}
      <h2 className="quiz-pergunta">Qual é o seu gênero?</h2>
      <p className="quiz-texto-extra">Essa informação nos ajuda a calcular sua taxa metabólica basal.</p>

      {/* ✅ Opções */}
      <div className="quiz-opcoes">
        {opcoes.map((opcao) => (
          <div
            key={opcao.valor}
            className={`quiz-opcao ${selecionado === opcao.valor ? 'selecionado' : ''}`}
            onClick={() => setSelecionado(opcao.valor)}
          >
            <span className="emoji">{opcao.emoji}</span>
            {opcao.label}
          </div>
        ))}
      </div>

      {erro && <p className="quiz-erro">{erro}</p>}

      <button
        className={`quiz-botao ${selecionado && !enviando ? 'ativo' : ''}`}
        onClick={handleEnviar}
        disabled={!selecionado || enviando}
      >
        {enviando ? 'Enviando...' : 'Continuar'}
      </button>

      {/* ✅ Footer padrão */}
      <div className="quiz-footer">
        <Footer />
      </div>
    </div>
  );
};

export default Genero;
